import React from "react";

// region Atoms
import { SelectClient } from "@atoms/index";
import ExternalSvg from "@atoms/ExternalSvg";
// endregion Atoms

import * as Styled from "./styles";

interface ClientSelectorOfficeProps {
  showSelectClient: boolean;
}

const ClientSelectorOffice: React.FC<ClientSelectorOfficeProps> = ({
  showSelectClient
}) => (
  <Styled.Container>
    <Styled.SelectContainer>
      {showSelectClient && <SelectClient showBorderBottom />}
    </Styled.SelectContainer>
    <Styled.IconContainer>
      <ExternalSvg svgName="LogotipoMinifiedColor" />
    </Styled.IconContainer>
  </Styled.Container>
);

export default ClientSelectorOffice;
